import { LandingPageBase } from '../landing-page-base/landing-page-base.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-guid-invalid',
    templateUrl: './guid-invalid.component.html',
    styleUrls: ['./guid-invalid.component.css'],
    standalone: true,
    imports: [MatCardModule, MatButtonModule, CommonModule, LandingPageBase]
})
export class GuidInvalid {
    headerText: string = 'Link Invalid';
    contentText: string = 'There was an issue validating your link. If the issue persist, please contact the Minster Law team on {{TEMP_TO_REPLACE_WITH_CONTACT}} to get a new link.';

    constructor() {
    }

    ngOnInit(): void {
    }
}
